import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/core';
import { AlgoliaClientService } from '@wizbii-utils/angular/algolia';
import { SearchResponse } from 'algoliasearch';
import { Observable } from 'rxjs';

@Injectable()
export class AlgoliaWebservice {
  readonly #algoliaClientService = inject(AlgoliaClientService);
  readonly #transferState = inject(TransferState);
  readonly #platformId = inject(PLATFORM_ID);

  #nbRequest = 0;

  searchByKeyWords<T>(
    index: string,
    query = '',
    facetFilters: (string | string[])[] = [],
    length = 6,
    offset = 0,
    filters = '',
    aroundLatLng = ''
  ): Observable<SearchResponse<T> | null> {
    const params: { [key: string]: any } = {
      facetFilters,
      offset,
      length,
      filters,
      facets: '*',
      aroundLatLng,
    };

    return new Observable<SearchResponse<T> | null>((observer) => {
      const ALGOLIA_KEY = makeStateKey<SearchResponse<T>>(`algolia-${index}-${this.#nbRequest}`);
      this.#nbRequest++;

      if (this.#transferState.hasKey(ALGOLIA_KEY)) {
        const content = this.#transferState.get<SearchResponse<T> | null>(ALGOLIA_KEY, null);
        this.#transferState.remove<SearchResponse<T>>(ALGOLIA_KEY);
        observer.next(content);
        observer.complete();
      } else {
        this.#algoliaClientService.client
          .searchForHits<T>({
            requests: [
              {
                indexName: index,
                query,
                facetFilters,
                offset,
                length,
                filters,
                facets: ['*'],
                aroundLatLng,
              },
            ],
          })
          .then((content) => {
            if (isPlatformServer(this.#platformId)) {
              this.#transferState.set<SearchResponse<T>>(ALGOLIA_KEY, content.results[0]);
            }

            observer.next(content.results[0]);
            observer.complete();
          })
          .catch((err) => {
            observer.error(err);
          });
      }
    });
  }
}
